import React from 'react'
import { useChannelStateContext, useChatContext } from 'stream-chat-react'
import type { CustomMessageActionsListProps } from 'stream-chat-react'
import { t } from 'ttag'
import Bugsnag from '@bugsnag/js'

// Extends the message actions box ("...") with moderation actions. Stream only exposes the
// action to users whose channel role grants it: own_capabilities is computed server-side,
// so regular members never see the Ban entry.
export const YumCustomMessageActionsList = (props: CustomMessageActionsListProps) => {
  const { message } = props
  const { channel } = useChannelStateContext('YumCustomMessageActionsList')
  const { client } = useChatContext('YumCustomMessageActionsList')

  // @ts-ignore // own_capabilities exists on channel data
  const capabilities: string[] = channel?.data?.own_capabilities || []
  const targetUserId = message?.user?.id
  const canBan = capabilities.includes('ban-channel-members') && !!targetUserId && targetUserId !== client.userID

  if (!canBan) return null

  const handleBan = async (event: React.BaseSyntheticEvent) => {
    event.preventDefault()
    try {
      await channel.banUser(targetUserId!, { banned_by_id: client.userID })
    } catch (e: any) {
      console.error('banUser failed: ', e)
      Bugsnag.notify(e)
    }
  }

  return (
    <button
      aria-selected="false"
      className="str-chat__message-actions-list-item str-chat__message-actions-list-item-button"
      role="option"
      onClick={handleBan}
    >
      {t`Ban user`}
    </button>
  )
}
